import { createUseStyles } from "react-jss";

export default createUseStyles({
    radioIcon: {
        composes: "radio__icon",
        verticalAlign: "middle",
        fontSize: 23,
        pointerEvents: "none",
        "& .custom__Image": {
            "max-height": "100%",
        },
    },
    radioIconChecked: {
        composes: "radio__icon--checked",
    },
    radioIconDisabled: {
        composes: "radio__icon--disabled",
        opacity: 0.5,
    },
});
